module.exports = __webpack_public_path__ + "img/safetypay.2da8359.png";